export type EnvironmentName = "development" | "production";

export default (): EnvironmentName => {
    return process.env.NODE_ENV as EnvironmentName;
};
